<template>
  <Popover placement="bottom" :width="342">
    <div title="Filter Due Dates" class="drop-down-button" style="margin-right: 10px">
        <i class="fal fa-calendar"></i>
    </div>
    <div slot="content" class="due-date-filters">
      <div class="filter-tools-fixed">
          <div class="drop-down-filter-header">
            <h3 class="filter-header">Filter Due Dates</h3>
            <div style="clear: both;"></div>
          </div>
      </div>
      <div class="filter-content">                
        <div v-for="label in dateOptions" v-bind:key="label" class="list-item" @click="dateTypeChanged(label); popupOptions.type = label;"> 
          <div class="list-item-title">{{label}}</div>
          <input class="filter-checkbox" type="radio" :value="label" @change="dateTypeChanged(label)" v-model="popupOptions.type">
        </div>
      </div>
      <div v-show="popupOptions.type === 'Custom'" class="dates-selector">
        <div>
          <div class="datepicker-trigger">
            <input
              type="text"
              id="datepicker-trigger"
              placeholder="Select dates"
              :value="formatDates(fromDate, toDate)"
            >

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'range'"
              :monthsToShow="1"
              :fullscreen-mobile="true"
              :date-one="fromDate"
              :date-two="toDate"
              @date-one-selected="val => { fromDate = val }"
              @date-two-selected="val => { toDate = val }"
              :offsetY="-396"
              :showShortcutsMenuTrigger="false"
              @apply="setCustomDate()"
              :fullscreenMobile="false"
            />
          </div>
        </div>
      </div>
    </div>
  </Popover>
</template>

<script>
  const _ = require('lodash');
  import Vue from 'vue';
  // import bulmaCalendar from 'bulma-calendar/dist/js/bulma-calendar.min.js';
  import utils from '@/utils/utils.js';
  import Popover from '../popover';
  import format from 'date-fns/format'
  
  const moment = require('moment'); 
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  export default {
    name: 'DueDateFilter',
    components: {
      Popover
    },
    data: function () {
      var t = this;

      return {
       utils: utils,
       error: '',
       dateOptions: ['All dates', 'Today', 'Tomorrow', 'This week', 'Next week', 'Custom'],
       selectAllText: 'Deselect all',
       dateFormat: 'DD MMM YYYY',
       fromDate: '',
       toDate: ''
      }
    },
    props: [
      'resourceTypes', 'dateFilterApplied', 'popupOptions'
    ],
    mounted: function () {
      
    },    
    methods: {
      formatDates(fromDate, toDate) {
        let formattedDates = '';
        if (fromDate) {
          formattedDates = format(fromDate, this.dateFormat);
        }
        if (toDate) {
          formattedDates += ' > ' + format(toDate, this.dateFormat);
        }
        return formattedDates;
      },
      dateTypeChanged: function(type) {
        var t = this;

        if(type === "Custom" && t.fromDate && t.toDate) {
          Vue.set(t.popupOptions, 'fromDate', moment(t.fromDate, 'YYYY-MM-DD').startOf('day').unix());
          Vue.set(t.popupOptions, 'toDate', moment(t.toDate, 'YYYY-MM-DD').endOf('day').unix());
          t.dateFilterApplied();
        } else if(type === "All dates") {
          Vue.set(t.popupOptions, 'fromDate', -1);
          Vue.set(t.popupOptions, 'toDate', -1);
        } else if(type === "Today") {
          Vue.set(t.popupOptions, 'fromDate', moment().startOf('day').unix());
          Vue.set(t.popupOptions, 'toDate', moment().endOf('day').unix());
        } else if(type === "Tomorrow") {
          Vue.set(t.popupOptions, 'fromDate', moment().add(1,'days').startOf('day').unix());
          Vue.set(t.popupOptions, 'toDate', moment().add(1,'days').endOf('day').unix());
        } else if(type === "This week") {
          Vue.set(t.popupOptions, 'fromDate', moment().startOf('week').add(1, 'day').startOf('day').unix()); // week starts on a Sunday hence the + 1 day
          Vue.set(t.popupOptions, 'toDate', moment().endOf('week').add(1, 'day').endOf('day').unix());// week starts on a Sunday hence the + 1 day
        } else if(type === "Next week") {
          Vue.set(t.popupOptions, 'fromDate', moment().add(1,'week').startOf('week').add(1, 'day').startOf('day').unix());// week starts on a Sunday hence the + 1 day
          Vue.set(t.popupOptions, 'toDate', moment().add(1,'week').endOf('week').add(1, 'day').endOf('day').unix());// week starts on a Sunday hence the + 1 day
        } else {
          Vue.set(t.popupOptions, 'fromDate', -1);
          Vue.set(t.popupOptions, 'toDate', -1);
        }

        t.dateFilterApplied();
      },
      setCustomDate: function() {
        var t = this;
        Vue.set(t.popupOptions, 'fromDate', moment(t.fromDate, 'YYYY-MM-DD').startOf('day').unix());
        Vue.set(t.popupOptions, 'toDate', moment(t.toDate, 'YYYY-MM-DD').endOf('day').unix());
        t.dateFilterApplied();
      }
    }
  }
</script>

<style lang="scss" scoped>
// @import "~bulma-calendar/dist/css/bulma-calendar.min.css";
@import '~vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';
.due-date-filters {

  .filter-content img {
    height: 32px !important;
  }

  .dates-selector {
    padding-right: 10px;
    padding-top: 10px;
  }

  .datetimepicker {
    top: 20px;
  }

  .list-item {
    padding: 10px 0;
  }

  .list-item-title {
    width: 255px;
  }

  .datetimepicker.is-datetimepicker-default .datetimepicker-container:after, .datetimepicker.is-datetimepicker-default .datetimepicker-container:before {
    border: 0 !important;
  }

  .datetimepicker.is-datetimepicker-default:after, .datetimepicker.is-datetimepicker-default:before {
    left: 15%;
    border: solid transparent;
    border-color: rgba(74,74,74,0);
    border-top-color: white;
    border-width: .75rem;
    margin-left: -.75rem;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .datetimepicker.is-datetimepicker-default:before {
    bottom: -25px;
    border-top-color: #999;
  }
}

@media only screen and (max-width: 600px) {
  .due-date-filters {
    .book-title {
      max-width: calc(100vw - 35px);
    }
    .list-item label {
      width: 270px;
    }
  }
}
</style>
